import script from "./VslTimer.vue?vue&type=script&setup=true&lang=js"
export * from "./VslTimer.vue?vue&type=script&setup=true&lang=js"

import "./VslTimer.vue?vue&type=style&index=0&id=1b7c170e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b7c170e"]])

export default __exports__